import domReady from '@wordpress/dom-ready';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

domReady(() => {
	const header = document.querySelector('#header');
	if (header) {
		const body = document.querySelector('body');
		const headerNav = header.querySelector('.header-nav');
		const headerBurger = header.querySelector('.header-burger');
		const headerBurgerLines = headerBurger.querySelectorAll('span');
		const headerSubmenus = header.querySelectorAll(
			'.header-submenu[data-menu-item]'
		);

		ScrollTrigger.create({
			start: 0,
			end: 99999,
			onEnter: () => {
				header.dataset.fill = 1;
			},
			onLeaveBack: () => {
				header.dataset.fill = 0;
			},
		});

		ScrollTrigger.create({
			start: 100,
			end: 99999,
			onEnter: () => {
				document.body.classList.add('has-scroll');
			},
			onLeaveBack: () => {
				document.body.classList.remove('has-scroll');
			},
		});

		// Burger animation
		if (headerNav && headerBurger) {
			const timeline = gsap.timeline({
				paused: true,
				onReverseComplete: function () {
					gsap.set([headerBurgerLines], {
						clearProps: 'all',
					});
				},
			});
			timeline
				.to(headerBurgerLines[0], {
					width: '100%',
					rotate: 45,
					duration: 0.2,
					y: 11,
				})
				.to(
					headerBurgerLines[1],
					{
						width: '100%',
						scaleX: 0,
						duration: 0.2,
					},
					'<'
				)
				.to(
					headerBurgerLines[2],
					{
						width: '100%',
						rotate: -45,
						duration: 0.2,
						y: -11,
					},
					'<'
				);

			const timelineReverse = () => {
				[...headerSubmenus].forEach((el) => (el.dataset.open = 0));
				if (header.dataset.open === '1') {
					header.dataset.open = 0;
				} else {
					header.dataset.open = '-1';
					setTimeout(() => {
						header.dataset.open = '0';
					}, 200);
				}
				timeline.reverse();
				body.classList.remove('is-freeze');
			};

			headerBurger.addEventListener('click', () => {
				if (!header.dataset.open || header.dataset.open == '0') {
					header.dataset.open = 1;
					timeline.play();
					body.classList.add('is-freeze');
				} else {
					timelineReverse();
				}
			});

			window.addEventListener('resize', timelineReverse);
			window.addEventListener('scroll', timelineReverse);
		}

		// Submenus animations
		const headerMenuItems = header.querySelectorAll(
			'.header-menu-item[data-slug]'
		);
		if (headerMenuItems.length) {
			const reverseSubmenu = (submenu = null) => {
				if (submenu && submenu.dataset.open === '1') {
					submenu.dataset.open = 0;
				} else {
					[...headerSubmenus].forEach((el) => (el.dataset.open = 0));
				}
			};

			headerMenuItems.forEach((item) => {
				const slug = item.dataset.slug;
				const submenu = document.querySelector(
					`.header-submenu[data-menu-item="${slug}"]`
				);

				if (submenu) {
					const top = submenu.querySelector('.header-submenu-top');
					const others = [
						...header.querySelectorAll(
							'.header-submenu[data-menu-item]'
						),
					].filter((el) => {
						const key = el.dataset.menuItem;
						return slug !== key;
					});

					item.addEventListener('click', (e) => {
						if (
							!submenu.dataset.open ||
							submenu.dataset.open == '0'
						) {
							submenu.dataset.open = 1;
							header.dataset.open = 2;
							others.forEach((el) => (el.dataset.open = 0));
						} else if (header.dataset.open == '2') {
							submenu.dataset.open = 0;
							header.dataset.open = 0;
						} else {
							submenu.dataset.open = 0;
							header.dataset.open = 1;
						}
					});

					top.addEventListener('click', () => {
						if (submenu.dataset.open !== '1') {
							submenu.dataset.open = 1;
							header.dataset.open = 2;
						} else {
							submenu.dataset.open = 0;
							header.dataset.open = 1;
						}
					});
				}
			});

			document.addEventListener('click', (e) => {
				const isHeader = e.target.closest('#header');
				if (!isHeader) {
					header.dataset.open = 0;
					reverseSubmenu();
				}
			});

			window.addEventListener('scroll', () => {
				reverseSubmenu();
			});
			window.addEventListener('resize', () => {
				reverseSubmenu();
			});
		}

		// Clone socials
		const headerSocials = header.querySelector(
			'.header-submenu-more-item .wp-block-social-links'
		);
		const headerNavMore = header.querySelector('.header-nav .header-more');
		if (headerSocials && headerNavMore) {
			headerNavMore.innerHTML =
				headerNavMore.innerHTML + headerSocials.outerHTML;
		}
	}
});
